// import React, { useState, useEffect } from 'react';
// import { FaSave, FaPlus, FaTrash } from 'react-icons/fa';

// const AdminPricingPanel = () => {
//   // Stan dla danych cennika
//   const [pricingData, setPricingData] = useState({
//     title: "Cennik",
//     apartamenty: {
//       title: "Apartamenty Kolorowe Domki 4-8 osobowe",
//       table: [
//         { term: "01.05.2025 - 04.05.2025", price: "400 PLN" },
//         { term: "05.05.2025 - 27.06.2025", price: "270 PLN" },
//         { term: "28.06.2025 - 11.07.2025", price: "450 PLN" },
//         { term: "12.07.2025 - 17.08.2025", price: "500 PLN" },
//         { term: "18.08.2025 - 31.08.2025", price: "450 PLN" },
//         { term: "01.09.2025 - 30.09.2025", price: "270 PLN" }
//       ],
//       notes: [
//         "Podane ceny obowiązują przy pobytach co najmniej 3 dniowych.",
//         "Pobyt Boże Ciało cena 400 PLN/doba. Pobyty krótsze wyceniamy indywidualnie.",
//         "Każda dodatkowa osoba w Apartamecie za dopłatą 50 PLN/doba. Maksymalna ilość osób wynosi 8 (razem z dziećmi).",
//         "Opłata za małe zwierzęta (psy i koty) wynosi 20 PLN/doba."
//       ],
//       uwagi: [
//         "Ceny zawierają opłaty za wodę i prąd, opłatę klimatyczną i miejsce parkingowe.",
//         "Ceny nie zawierają opłaty za ewentualne ogrzewanie elektryczne – płatność za rzeczywiste zużycie według wskazań licznika."
//       ],
//       warunki: "Rezerwacje uważa się za potwierdzoną po wpłaceniu zaliczki w wysokości 3 dniowego pobytu w terminie 3 dni od dokonania rezerwacji telefonicznej lub e-mail. Pozostałą kwotę należy uiścić w dniu przyjazdu przy zameldowaniu.",
//       danePrzelewowe: {
//         nazwa: "Wynajem Domków Urszula Drużna",
//         numerRachunku: "70 1050 1924 1000 0092 3962 2898",
//         tytulPrzelewu: "Imię i Nazwisko, termin pobytu i numer telefonu"
//       }
//     },
//     domki: {
//       title: "Kolorowe Domki 4-6 osobowe",
//       table: [
//         { term: "01.06.2025 - 27.06.2025", price: "200 PLN" },
//         { term: "28.06.2025 - 11.07.2025", price: "350 PLN" },
//         { term: "12.07.2025 - 17.08.2025", price: "400 PLN" },
//         { term: "18.08.2025 - 31.08.2025", price: "350 PLN" },
//         { term: "01.09.2025 - 30.09.2025", price: "200 PLN" }
//       ],
//       notes: [
//         "Podane ceny obowiązują przy pobytach co najmniej 3 dniowych.",
//         "Pobyty krótsze oraz na Boże Ciało (300 PLN/doba) wyceniamy indywidualnie.",
//         "Każda dodatkowa osoba w domku za dopłatą 30 PLN/doba. Maksymalna ilość osób wynosi 6 (2 osoby dorosłe i reszta dzieci).",
//         "Opłata za małe zwierzęta (psy i koty) wynosi 20 PLN/doba."
//       ],
//       uwagi: [
//         "Ceny zawierają opłaty za wodę i prąd, opłatę klimatyczną oraz miejsce parkingowe."
//       ],
//       warunki: "Rezerwacje uważa się za potwierdzoną po wpłaceniu zaliczki w wysokości 3 dniowego pobytu w terminie 3 dni od dokonania rezerwacji telefonicznej lub e-mail. Pozostałą kwotę należy uiścić w dniu przyjazdu przy zameldowaniu.",
//       danePrzelewowe: {
//         nazwa: "Irena Drużna",
//         numerRachunku: "17 1050 1041 1000 0092 0616 4031",
//         tytulPrzelewu: "Imię i Nazwisko, termin pobytu i numer telefonu"
//       }
//     }
//   });

//   const [message, setMessage] = useState("");

//   // Załaduj dane z localStorage przy starcie
//   useEffect(() => {
//     const savedData = localStorage.getItem('pricingData');
//     if (savedData) {
//       try {
//         setPricingData(JSON.parse(savedData));
//       } catch (error) {
//         console.error('Błąd parsowania danych cennika:', error);
//       }
//     }
//   }, []);

//   const saveData = () => {
//     localStorage.setItem('pricingData', JSON.stringify(pricingData));
//     setMessage("Zmiany zapisane pomyślnie!");
//     setTimeout(() => setMessage(""), 3000);
//   };

//   const handleGeneralChange = (field, value) => {
//     setPricingData({
//       ...pricingData,
//       [field]: value
//     });
//   };

//   const handleSectionChange = (section, field, value) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         [field]: value
//       }
//     });
//   };

//   const handleTableRowChange = (section, index, field, value) => {
//     const updatedTable = [...pricingData[section].table];
//     updatedTable[index] = {
//       ...updatedTable[index],
//       [field]: value
//     };
    
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         table: updatedTable
//       }
//     });
//   };

//   const addTableRow = (section) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         table: [...pricingData[section].table, { term: "", price: "" }]
//       }
//     });
//   };

//   const removeTableRow = (section, index) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         table: pricingData[section].table.filter((_, i) => i !== index)
//       }
//     });
//   };

//   const handleNoteChange = (section, index, value) => {
//     const updatedNotes = [...pricingData[section].notes];
//     updatedNotes[index] = value;
    
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         notes: updatedNotes
//       }
//     });
//   };

//   const addNote = (section) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         notes: [...pricingData[section].notes, ""]
//       }
//     });
//   };

//   const removeNote = (section, index) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         notes: pricingData[section].notes.filter((_, i) => i !== index)
//       }
//     });
//   };

//   const handleUwagiChange = (section, index, value) => {
//     const updatedUwagi = [...pricingData[section].uwagi];
//     updatedUwagi[index] = value;
    
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         uwagi: updatedUwagi
//       }
//     });
//   };

//   const addUwagi = (section) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         uwagi: [...pricingData[section].uwagi, ""]
//       }
//     });
//   };

//   const removeUwagi = (section, index) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         uwagi: pricingData[section].uwagi.filter((_, i) => i !== index)
//       }
//     });
//   };

//   const handleDanePrzelewoweChange = (section, field, value) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         danePrzelewowe: {
//           ...pricingData[section].danePrzelewowe,
//           [field]: value
//         }
//       }
//     });
//   };

//   const renderEditableTable = (section, title) => (
//     <div className="mb-8 p-4 border border-gray-200 rounded-md">
//       <h3 className="text-xl font-semibold mb-4">{title}</h3>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
//         <input
//           type="text"
//           value={pricingData[section].title}
//           onChange={(e) => handleSectionChange(section, 'title', e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md"
//         />
//       </div>

//       <div className="mb-6">
//         <h4 className="font-semibold mb-3">Tabela cen</h4>
//         <div className="space-y-3">
//           {pricingData[section].table.map((row, index) => (
//             <div key={index} className="flex gap-3 items-center">
//               <input
//                 type="text"
//                 value={row.term}
//                 onChange={(e) => handleTableRowChange(section, index, 'term', e.target.value)}
//                 placeholder="Termin (np. 01.05.2025 - 04.05.2025)"
//                 className="flex-1 p-2 border border-gray-300 rounded-md"
//               />
//               <input
//                 type="text"
//                 value={row.price}
//                 onChange={(e) => handleTableRowChange(section, index, 'price', e.target.value)}
//                 placeholder="Cena (np. 400 PLN)"
//                 className="w-32 p-2 border border-gray-300 rounded-md"
//               />
//               <button
//                 onClick={() => removeTableRow(section, index)}
//                 className="p-2 bg-red-100 text-red-600 rounded-md"
//               >
//                 <FaTrash />
//               </button>
//             </div>
//           ))}
//         </div>
//         <button
//           onClick={() => addTableRow(section)}
//           className="mt-3 flex items-center gap-2 bg-blue-500 text-white px-3 py-2 rounded-md"
//         >
//           <FaPlus /> Dodaj wiersz
//         </button>
//       </div>

//       <div className="mb-6">
//         <h4 className="font-semibold mb-3">Uwagi i informacje</h4>
//         <div className="space-y-3">
//           {pricingData[section].notes.map((note, index) => (
//             <div key={index} className="flex gap-3 items-center">
//               <input
//                 type="text"
//                 value={note}
//                 onChange={(e) => handleNoteChange(section, index, e.target.value)}
//                 className="flex-1 p-2 border border-gray-300 rounded-md"
//                 placeholder="Uwaga/informacja"
//               />
//               <button
//                 onClick={() => removeNote(section, index)}
//                 className="p-2 bg-red-100 text-red-600 rounded-md"
//               >
//                 <FaTrash />
//               </button>
//             </div>
//           ))}
//         </div>
//         <button
//           onClick={() => addNote(section)}
//           className="mt-3 flex items-center gap-2 bg-blue-500 text-white px-3 py-2 rounded-md"
//         >
//           <FaPlus /> Dodaj uwagę
//         </button>
//       </div>

//       <div className="mb-6">
//         <h4 className="font-semibold mb-3">Dodatkowe uwagi</h4>
//         <div className="space-y-3">
//           {pricingData[section].uwagi.map((uwaga, index) => (
//             <div key={index} className="flex gap-3 items-center">
//               <input
//                 type="text"
//                 value={uwaga}
//                 onChange={(e) => handleUwagiChange(section, index, e.target.value)}
//                 className="flex-1 p-2 border border-gray-300 rounded-md"
//                 placeholder="Dodatkowa uwaga"
//               />
//               <button
//                 onClick={() => removeUwagi(section, index)}
//                 className="p-2 bg-red-100 text-red-600 rounded-md"
//               >
//                 <FaTrash />
//               </button>
//             </div>
//           ))}
//         </div>
//         <button
//           onClick={() => addUwagi(section)}
//           className="mt-3 flex items-center gap-2 bg-blue-500 text-white px-3 py-2 rounded-md"
//         >
//           <FaPlus /> Dodaj uwagę
//         </button>
//       </div>

//       <div className="mb-6">
//         <h4 className="font-semibold mb-3">Warunki rezerwacji</h4>
//         <textarea
//           value={pricingData[section].warunki}
//           onChange={(e) => handleSectionChange(section, 'warunki', e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md h-24"
//           placeholder="Warunki rezerwacji"
//         />
//       </div>

//       <div className="mb-6 p-4 bg-blue-50 rounded-md">
//         <h4 className="font-semibold mb-3">Dane do przelewów</h4>
//         <div className="space-y-3">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Nazwa odbiorcy</label>
//             <input
//               type="text"
//               value={pricingData[section].danePrzelewowe.nazwa}
//               onChange={(e) => handleDanePrzelewoweChange(section, 'nazwa', e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Numer rachunku</label>
//             <input
//               type="text"
//               value={pricingData[section].danePrzelewowe.numerRachunku}
//               onChange={(e) => handleDanePrzelewoweChange(section, 'numerRachunku', e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md font-mono"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Tytuł przelewu</label>
//             <input
//               type="text"
//               value={pricingData[section].danePrzelewowe.tytulPrzelewu}
//               onChange={(e) => handleDanePrzelewoweChange(section, 'tytulPrzelewu', e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
//         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Cennik</h1>
        
//         {message && (
//           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
//             {message}
//           </div>
//         )}
        
//         {/* Nagłówek sekcji */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-3">Nagłówek sekcji</h2>
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
//             <input
//               type="text"
//               value={pricingData.title}
//               onChange={(e) => handleGeneralChange('title', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md"
//             />
//           </div>
//         </div>

//         {/* Apartamenty DeLuxe */}
//         {renderEditableTable('apartamenty', 'Apartamenty DeLuxe')}

//         {/* Kolorowe Domki */}
//         {renderEditableTable('domki', 'Kolorowe Domki')}

//         {/* Zapisywanie */}
//         <div className="flex justify-end">
//           <button
//             onClick={saveData}
//             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
//           >
//             <FaSave /> Zapisz zmiany
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminPricingPanel;

// import React, { useState, useEffect } from 'react';
// import { FaSave, FaPlus, FaTrash } from 'react-icons/fa';

// const AdminPricingPanel = () => {
//   const API_BASE = 'http://localhost/api';

//   // Stan dla danych cennika
//   const [pricingData, setPricingData] = useState({
//     title: "Cennik",
//     apartamenty: {
//       title: "Apartamenty Kolorowe Domki 4-8 osobowe",
//       table: [
//         { term: "01.05.2025 - 04.05.2025", price: "400 PLN" },
//         { term: "05.05.2025 - 27.06.2025", price: "270 PLN" },
//         { term: "28.06.2025 - 11.07.2025", price: "450 PLN" },
//         { term: "12.07.2025 - 17.08.2025", price: "500 PLN" },
//         { term: "18.08.2025 - 31.08.2025", price: "450 PLN" },
//         { term: "01.09.2025 - 30.09.2025", price: "270 PLN" }
//       ],
//       notes: [
//         "Podane ceny obowiązują przy pobytach co najmniej 3 dniowych.",
//         "Pobyt Boże Ciało cena 400 PLN/doba. Pobyty krótsze wyceniamy indywidualnie.",
//         "Każda dodatkowa osoba w Apartamecie za dopłatą 50 PLN/doba. Maksymalna ilość osób wynosi 8 (razem z dziećmi).",
//         "Opłata za małe zwierzęta (psy i koty) wynosi 20 PLN/doba."
//       ],
//       uwagi: [
//         "Ceny zawierają opłaty za wodę i prąd, opłatę klimatyczną i miejsce parkingowe.",
//         "Ceny nie zawierają opłaty za ewentualne ogrzewanie elektryczne – płatność za rzeczywiste zużyce według wskazań licznika."
//       ],
//       warunki: "Rezerwacje uważa się za potwierdzoną po wpłaceniu zaliczki w wysokości 3 dniowego pobytu w terminie 3 dni od dokonania rezerwacji telefonicznej lub e-mail. Pozostałą kwotę należy uiścić w dniu przyjazdu przy zameldowaniu.",
//       danePrzelewowe: {
//         nazwa: "Wynajem Domków Urszula Drużna",
//         numerRachunku: "70 1050 1924 1000 0092 3962 2898",
//         tytulPrzelewu: "Imię i Nazwisko, termin pobytu i numer telefonu"
//       }
//     },
//     domki: {
//       title: "Kolorowe Domki 4-6 osobowe",
//       table: [
//         { term: "01.06.2025 - 27.06.2025", price: "200 PLN" },
//         { term: "28.06.2025 - 11.07.2025", price: "350 PLN" },
//         { term: "12.07.2025 - 17.08.2025", price: "400 PLN" },
//         { term: "18.08.2025 - 31.08.2025", price: "350 PLN" },
//         { term: "01.09.2025 - 30.09.2025", price: "200 PLN" }
//       ],
//       notes: [
//         "Podane ceny obowiązują przy pobytach co najmniej 3 dniowych.",
//         "Pobyty krótsze oraz na Boże Ciało (300 PLN/doba) wyceniamy indywidualnie.",
//         "Każda dodatkowa osoba w domku za dopłatą 30 PLN/doba. Maksymalna ilość osób wynosi 6 (2 osoby dorosłe i reszta dzieci).",
//         "Opłata za małe zwierzęta (psy i koty) wynosi 20 PLN/doba."
//       ],
//       uwagi: [
//         "Ceny zawierają opłaty za wodę i prąd, opłatę klimatyczną oraz miejsce parkingowe."
//       ],
//       warunki: "Rezerwacje uważa się za potwierdzoną po wpłaceniu zaliczki w wysokości 3 dniowego pobytu w terminie 3 dni od dokonania rezerwacji telefonicznej lub e-mail. Pozostałą kwotę należy uiścić w dniu przyjazdu przy zameldowaniu.",
//       danePrzelewowe: {
//         nazwa: "Irena Drużna",
//         numerRachunku: "17 1050 1041 1000 0092 0616 4031",
//         tytulPrzelewu: "Imię i Nazwisko, termin pobytu i numer telefonu"
//       }
//     }
//   });

//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(true);

//   // Załaduj dane z serwera
//   useEffect(() => {
//     const fetchPricingData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/pricing.php`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych cennika');
//         }
        
//         const data = await response.json();
//         setPricingData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych cennika:', error);
//         setMessage('Błąd połączenia z serwerem - używam domyślnych danych');
//         setTimeout(() => setMessage(""), 5000);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPricingData();
//   }, []);

//   // Zapisz dane na serwerze
//   const saveData = () => {
//     fetch(`${API_BASE}/pricing.php`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(pricingData),
//     })
//     .then(response => {
//       if (!response.ok) {
//         throw new Error('Błąd serwera');
//       }
//       return response.json();
//     })
//     .then(data => {
//       setMessage(data.message || "Zmiany zapisane pomyślnie!");
//       setTimeout(() => setMessage(""), 3000);
//     })
//     .catch(error => {
//       setMessage("Błąd podczas zapisywania danych");
//       console.error('Błąd:', error);
//       setTimeout(() => setMessage(""), 5000);
//     });
//   };

//   const handleGeneralChange = (field, value) => {
//     setPricingData({
//       ...pricingData,
//       [field]: value
//     });
//   };

//   const handleSectionChange = (section, field, value) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         [field]: value
//       }
//     });
//   };

//   const handleTableRowChange = (section, index, field, value) => {
//     const updatedTable = [...pricingData[section].table];
//     updatedTable[index] = {
//       ...updatedTable[index],
//       [field]: value
//     };
    
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         table: updatedTable
//       }
//     });
//   };

//   const addTableRow = (section) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         table: [...pricingData[section].table, { term: "", price: "" }]
//       }
//     });
//   };

//   const removeTableRow = (section, index) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         table: pricingData[section].table.filter((_, i) => i !== index)
//       }
//     });
//   };

//   const handleNoteChange = (section, index, value) => {
//     const updatedNotes = [...pricingData[section].notes];
//     updatedNotes[index] = value;
    
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         notes: updatedNotes
//       }
//     });
//   };

//   const addNote = (section) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         notes: [...pricingData[section].notes, ""]
//       }
//     });
//   };

//   const removeNote = (section, index) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         notes: pricingData[section].notes.filter((_, i) => i !== index)
//       }
//     });
//   };

//   const handleUwagiChange = (section, index, value) => {
//     const updatedUwagi = [...pricingData[section].uwagi];
//     updatedUwagi[index] = value;
    
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         uwagi: updatedUwagi
//       }
//     });
//   };

//   const addUwagi = (section) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         uwagi: [...pricingData[section].uwagi, ""]
//       }
//     });
//   };

//   const removeUwagi = (section, index) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         uwagi: pricingData[section].uwagi.filter((_, i) => i !== index)
//       }
//     });
//   };

//   const handleDanePrzelewoweChange = (section, field, value) => {
//     setPricingData({
//       ...pricingData,
//       [section]: {
//         ...pricingData[section],
//         danePrzelewowe: {
//           ...pricingData[section].danePrzelewowe,
//           [field]: value
//         }
//       }
//     });
//   };

//   const renderEditableTable = (section, title) => (
//     <div className="mb-8 p-4 border border-gray-200 rounded-md">
//       <h3 className="text-xl font-semibold mb-4">{title}</h3>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
//         <input
//           type="text"
//           value={pricingData[section].title}
//           onChange={(e) => handleSectionChange(section, 'title', e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md"
//         />
//       </div>

//       <div className="mb-6">
//         <h4 className="font-semibold mb-3">Tabela cen</h4>
//         <div className="space-y-3">
//           {pricingData[section].table.map((row, index) => (
//             <div key={index} className="flex gap-3 items-center">
//               <input
//                 type="text"
//                 value={row.term}
//                 onChange={(e) => handleTableRowChange(section, index, 'term', e.target.value)}
//                 placeholder="Termin (np. 01.05.2025 - 04.05.2025)"
//                 className="flex-1 p-2 border border-gray-300 rounded-md"
//               />
//               <input
//                 type="text"
//                 value={row.price}
//                 onChange={(e) => handleTableRowChange(section, index, 'price', e.target.value)}
//                 placeholder="Cena (np. 400 PLN)"
//                 className="w-32 p-2 border border-gray-300 rounded-md"
//               />
//               <button
//                 onClick={() => removeTableRow(section, index)}
//                 className="p-2 bg-red-100 text-red-600 rounded-md"
//               >
//                 <FaTrash />
//               </button>
//             </div>
//           ))}
//         </div>
//         <button
//           onClick={() => addTableRow(section)}
//           className="mt-3 flex items-center gap-2 bg-blue-500 text-white px-3 py-2 rounded-md"
//         >
//           <FaPlus /> Dodaj wiersz
//         </button>
//       </div>

//       <div className="mb-6">
//         <h4 className="font-semibold mb-3">Uwagi i informacje</h4>
//         <div className="space-y-3">
//           {pricingData[section].notes.map((note, index) => (
//             <div key={index} className="flex gap-3 items-center">
//               <input
//                 type="text"
//                 value={note}
//                 onChange={(e) => handleNoteChange(section, index, e.target.value)}
//                 className="flex-1 p-2 border border-gray-300 rounded-md"
//                 placeholder="Uwaga/informacja"
//               />
//               <button
//                 onClick={() => removeNote(section, index)}
//                 className="p-2 bg-red-100 text-red-600 rounded-md"
//               >
//                 <FaTrash />
//               </button>
//             </div>
//           ))}
//         </div>
//         <button
//           onClick={() => addNote(section)}
//           className="mt-3 flex items-center gap-2 bg-blue-500 text-white px-3 py-2 rounded-md"
//         >
//           <FaPlus /> Dodaj uwagę
//         </button>
//       </div>

//       <div className="mb-6">
//         <h4 className="font-semibold mb-3">Dodatkowe uwagi</h4>
//         <div className="space-y-3">
//           {pricingData[section].uwagi.map((uwaga, index) => (
//             <div key={index} className="flex gap-3 items-center">
//               <input
//                 type="text"
//                 value={uwaga}
//                 onChange={(e) => handleUwagiChange(section, index, e.target.value)}
//                 className="flex-1 p-2 border border-gray-300 rounded-md"
//                 placeholder="Dodatkowa uwaga"
//               />
//               <button
//                 onClick={() => removeUwagi(section, index)}
//                 className="p-2 bg-red-100 text-red-600 rounded-md"
//               >
//                 <FaTrash />
//               </button>
//             </div>
//           ))}
//         </div>
//         <button
//           onClick={() => addUwagi(section)}
//           className="mt-3 flex items-center gap-2 bg-blue-500 text-white px-3 py-2 rounded-md"
//         >
//           <FaPlus /> Dodaj uwagę
//         </button>
//       </div>

//       <div className="mb-6">
//         <h4 className="font-semibold mb-3">Warunki rezerwacji</h4>
//         <textarea
//           value={pricingData[section].warunki}
//           onChange={(e) => handleSectionChange(section, 'warunki', e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-md h-24"
//           placeholder="Warunki rezerwacji"
//         />
//       </div>

//       <div className="mb-6 p-4 bg-blue-50 rounded-md">
//         <h4 className="font-semibold mb-3">Dane do przelewów</h4>
//         <div className="space-y-3">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Nazwa odbiorcy</label>
//             <input
//               type="text"
//               value={pricingData[section].danePrzelewowe.nazwa}
//               onChange={(e) => handleDanePrzelewoweChange(section, 'nazwa', e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Numer rachunku</label>
//             <input
//               type="text"
//               value={pricingData[section].danePrzelewowe.numerRachunku}
//               onChange={(e) => handleDanePrzelewoweChange(section, 'numerRachunku', e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md font-mono"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Tytuł przelewu</label>
//             <input
//               type="text"
//               value={pricingData[section].danePrzelewowe.tytulPrzelewu}
//               onChange={(e) => handleDanePrzelewoweChange(section, 'tytulPrzelewu', e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-100 p-6">
//         <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
//           <div className="flex justify-center items-center h-64">
//             <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
//         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Cennik</h1>
        
//         {message && (
//           <div className={`mb-4 p-3 rounded ${
//             message.includes('Błąd') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
//           }`}>
//             {message}
//           </div>
//         )}
        
//         {/* Nagłówek sekcji */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-3">Nagłówek sekcji</h2>
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
//             <input
//               type="text"
//               value={pricingData.title}
//               onChange={(e) => handleGeneralChange('title', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md"
//             />
//           </div>
//         </div>

//         {/* Apartamenty DeLuxe */}
//         {renderEditableTable('apartamenty', 'Apartamenty')}

//         {/* Kolorowe Domki */}
//         {renderEditableTable('domki', 'Kolorowe Domki')}

//         {/* Zapisywanie */}
//         <div className="flex justify-end">
//           <button
//             onClick={saveData}
//             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
//           >
//             <FaSave /> Zapisz zmiany
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminPricingPanel;

import React, { useState, useEffect } from 'react';
import { FaSave, FaPlus, FaTrash, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const AdminPricingPanel = () => {
  const API_BASE = '/api/content';
  const navigate = useNavigate();
  
  const [pricingData, setPricingData] = useState({
    title: "Cennik",
    apartamenty: {
      title: "Apartamenty Kolorowe Domki 4-8 osobowe",
      table: [],
      notes: [],
      uwagi: [],
      warunki: "",
      danePrzelewowe: {
        nazwa: "",
        numerRachunku: "",
        tytulPrzelewu: ""
      }
    },
    domki: {
      title: "Kolorowe Domki 4-6 osobowe",
      table: [],
      notes: [],
      uwagi: [],
      warunki: "",
      danePrzelewowe: {
        nazwa: "",
        numerRachunku: "",
        tytulPrzelewu: ""
      }
    }
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Załaduj dane z serwera
  useEffect(() => {
    fetchPricingData();
  }, []);

  const fetchPricingData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE}/get-pricing.php`);
      
      if (response.ok) {
        const data = await response.json();
        setPricingData(data);
      } else {
        throw new Error('Błąd podczas pobierania danych');
      }
    } catch (error) {
      console.error('Błąd ładowania danych cennika:', error);
      setMessage('Błąd połączenia z serwerem');
      setTimeout(() => setMessage(""), 5000);
    } finally {
      setLoading(false);
    }
  };

  // Zapisz dane na serwerze
  const saveData = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem('adminToken');
      
      const response = await fetch(`${API_BASE}/update-pricing.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(pricingData),
      });

      const data = await response.json();
      
      if (response.ok) {
        setMessage(data.message || "Zmiany zapisane pomyślnie!");
      } else {
        setMessage(data.message || "Błąd podczas zapisywania");
      }
      
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      setMessage("Błąd podczas zapisywania danych");
      console.error('Błąd:', error);
    } finally {
      setSaving(false);
    }
  };

  // Funkcje pomocnicze dla apartamentów
  const addApartamentTableRow = () => {
    setPricingData(prev => ({
      ...prev,
      apartamenty: {
        ...prev.apartamenty,
        table: [...prev.apartamenty.table, { term: "", price: "" }]
      }
    }));
  };

  const updateApartamentTableRow = (index, field, value) => {
    const newTable = [...pricingData.apartamenty.table];
    newTable[index][field] = value;
    setPricingData(prev => ({
      ...prev,
      apartamenty: { ...prev.apartamenty, table: newTable }
    }));
  };

  const removeApartamentTableRow = (index) => {
    const newTable = pricingData.apartamenty.table.filter((_, i) => i !== index);
    setPricingData(prev => ({
      ...prev,
      apartamenty: { ...prev.apartamenty, table: newTable }
    }));
  };

  // Funkcje pomocnicze dla domków
  const addDomkiTableRow = () => {
    setPricingData(prev => ({
      ...prev,
      domki: {
        ...prev.domki,
        table: [...prev.domki.table, { term: "", price: "" }]
      }
    }));
  };

  const updateDomkiTableRow = (index, field, value) => {
    const newTable = [...pricingData.domki.table];
    newTable[index][field] = value;
    setPricingData(prev => ({
      ...prev,
      domki: { ...prev.domki, table: newTable }
    }));
  };

  const removeDomkiTableRow = (index) => {
    const newTable = pricingData.domki.table.filter((_, i) => i !== index);
    setPricingData(prev => ({
      ...prev,
      domki: { ...prev.domki, table: newTable }
    }));
  };

  // Funkcje dla list (notes, uwagi)
  const addListItem = (section, listType) => {
    setPricingData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [listType]: [...prev[section][listType], ""]
      }
    }));
  };

  const updateListItem = (section, listType, index, value) => {
    const newList = [...pricingData[section][listType]];
    newList[index] = value;
    setPricingData(prev => ({
      ...prev,
      [section]: { ...prev[section], [listType]: newList }
    }));
  };

  const removeListItem = (section, listType, index) => {
    const newList = pricingData[section][listType].filter((_, i) => i !== index);
    setPricingData(prev => ({
      ...prev,
      [section]: { ...prev[section], [listType]: newList }
    }));
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 p-6">
        <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </div>
    );
  }

  const renderPricingSection = (sectionKey, sectionTitle) => {
    const section = pricingData[sectionKey];
    
    return (
      <div className="mb-8 p-6 border border-gray-200 rounded-lg">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">{sectionTitle}</h2>
        
        {/* Tytuł sekcji */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
          <input
            type="text"
            value={section.title}
            onChange={(e) => setPricingData(prev => ({
              ...prev,
              [sectionKey]: { ...prev[sectionKey], title: e.target.value }
            }))}
            className="w-full p-3 border border-gray-300 rounded-md"
          />
        </div>

        {/* Tabela cen */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Tabela cen</label>
          <div className="space-y-2">
            {section.table.map((row, index) => (
              <div key={index} className="flex gap-2 items-center">
                <input
                  type="text"
                  value={row.term}
                  onChange={(e) => sectionKey === 'apartamenty' 
                    ? updateApartamentTableRow(index, 'term', e.target.value)
                    : updateDomkiTableRow(index, 'term', e.target.value)
                  }
                  placeholder="Termin (np. 01.05.2025 - 04.05.2025)"
                  className="flex-1 p-2 border border-gray-300 rounded-md"
                />
                <input
                  type="text"
                  value={row.price}
                  onChange={(e) => sectionKey === 'apartamenty'
                    ? updateApartamentTableRow(index, 'price', e.target.value)
                    : updateDomkiTableRow(index, 'price', e.target.value)
                  }
                  placeholder="Cena (np. 400 PLN)"
                  className="w-32 p-2 border border-gray-300 rounded-md"
                />
                <button
                  onClick={() => sectionKey === 'apartamenty'
                    ? removeApartamentTableRow(index)
                    : removeDomkiTableRow(index)
                  }
                  className="p-2 bg-red-100 text-red-600 rounded-md hover:bg-red-200 transition-colors"
                >
                  <FaTrash />
                </button>
              </div>
            ))}
          </div>
          <button
            onClick={sectionKey === 'apartamenty' ? addApartamentTableRow : addDomkiTableRow}
            className="mt-2 flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
          >
            <FaPlus /> Dodaj wiersz
          </button>
        </div>

        {/* Uwagi */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Uwagi</label>
          <div className="space-y-2">
            {section.notes.map((note, index) => (
              <div key={index} className="flex gap-2">
                <input
                  type="text"
                  value={note}
                  onChange={(e) => updateListItem(sectionKey, 'notes', index, e.target.value)}
                  className="flex-1 p-2 border border-gray-300 rounded-md"
                  placeholder="Uwaga/informacja"
                />
                <button
                  onClick={() => removeListItem(sectionKey, 'notes', index)}
                  className="p-2 bg-red-100 text-red-600 rounded-md hover:bg-red-200 transition-colors"
                >
                  <FaTrash />
                </button>
              </div>
            ))}
          </div>
          <button
            onClick={() => addListItem(sectionKey, 'notes')}
            className="mt-2 flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 transition-colors"
          >
            <FaPlus /> Dodaj uwagę
          </button>
        </div>

        {/* Dodatkowe uwagi */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Dodatkowe uwagi</label>
          <div className="space-y-2">
            {section.uwagi.map((uwaga, index) => (
              <div key={index} className="flex gap-2">
                <input
                  type="text"
                  value={uwaga}
                  onChange={(e) => updateListItem(sectionKey, 'uwagi', index, e.target.value)}
                  className="flex-1 p-2 border border-gray-300 rounded-md"
                  placeholder="Dodatkowa uwaga"
                />
                <button
                  onClick={() => removeListItem(sectionKey, 'uwagi', index)}
                  className="p-2 bg-red-100 text-red-600 rounded-md hover:bg-red-200 transition-colors"
                >
                  <FaTrash />
                </button>
              </div>
            ))}
          </div>
          <button
            onClick={() => addListItem(sectionKey, 'uwagi')}
            className="mt-2 flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 transition-colors"
          >
            <FaPlus /> Dodaj uwagę
          </button>
        </div>

        {/* Warunki rezerwacji */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Warunki rezerwacji</label>
          <textarea
            value={section.warunki}
            onChange={(e) => setPricingData(prev => ({
              ...prev,
              [sectionKey]: { ...prev[sectionKey], warunki: e.target.value }
            }))}
            rows="3"
            className="w-full p-3 border border-gray-300 rounded-md"
            placeholder="Warunki rezerwacji"
          />
        </div>

        {/* Dane do przelewów */}
        <div className="mb-4 p-4 bg-gray-50 rounded-md">
          <h3 className="text-lg font-semibold mb-3">Dane do przelewów</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nazwa odbiorcy</label>
              <input
                type="text"
                value={section.danePrzelewowe.nazwa}
                onChange={(e) => setPricingData(prev => ({
                  ...prev,
                  [sectionKey]: {
                    ...prev[sectionKey],
                    danePrzelewowe: {
                      ...prev[sectionKey].danePrzelewowe,
                      nazwa: e.target.value
                    }
                  }
                }))}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Numer rachunku</label>
              <input
                type="text"
                value={section.danePrzelewowe.numerRachunku}
                onChange={(e) => setPricingData(prev => ({
                  ...prev,
                  [sectionKey]: {
                    ...prev[sectionKey],
                    danePrzelewowe: {
                      ...prev[sectionKey].danePrzelewowe,
                      numerRachunku: e.target.value
                    }
                  }
                }))}
                className="w-full p-2 border border-gray-300 rounded-md font-mono"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Tytuł przelewu</label>
              <input
                type="text"
                value={section.danePrzelewowe.tytulPrzelewu}
                onChange={(e) => setPricingData(prev => ({
                  ...prev,
                  [sectionKey]: {
                    ...prev[sectionKey],
                    danePrzelewowe: {
                      ...prev[sectionKey].danePrzelewowe,
                      tytulPrzelewu: e.target.value
                    }
                  }
                }))}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
        {/* Nagłówek z przyciskiem powrotu */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/admin/AdminMenuPanel')}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors"
            >
              <FaArrowLeft /> Powrót
            </button>
            <h1 className="text-2xl font-bold text-gray-800">Panel Administracyjny - Cennik</h1>
          </div>
        </div>
        
        {/* Komunikat */}
        {message && (
          <div className={`mb-4 p-3 rounded ${
            message.includes('Błąd') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
          }`}>
            {message}
          </div>
        )}

        {/* Tytuł główny */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł główny strony</label>
          <input
            type="text"
            value={pricingData.title}
            onChange={(e) => setPricingData(prev => ({ ...prev, title: e.target.value }))}
            className="w-full p-3 border border-gray-300 rounded-md text-xl font-bold"
          />
        </div>

        {/* Sekcja apartamentów */}
        {renderPricingSection('apartamenty', 'Apartamenty 4-8 osobowe')}

        {/* Sekcja domków */}
        {renderPricingSection('domki', 'Domki 4-6 osobowe')}

        {/* Przycisk zapisu */}
        <div className="flex justify-end">
          <button
            onClick={saveData}
            disabled={saving}
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {saving ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                Zapisywanie...
              </>
            ) : (
              <>
                <FaSave /> Zapisz zmiany
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminPricingPanel;